module.exports = __webpack_public_path__ + "img/thumbnail_RedKangaroo_m_normal.26f965a6.png";